import React, { useEffect, useRef } from 'react';
import { CLINICAL_SITUATIONS } from '../situations';
import { SituationId } from '../types';

interface SituationsPanelProps {
  open: boolean;
  selectedId: SituationId | null;
  onSelect: (id: SituationId) => void;
  onClose: () => void;
}

const SituationsPanel: React.FC<SituationsPanelProps> = ({
  open,
  selectedId,
  onSelect,
  onClose,
}) => {
  const firstOptionRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (!open) return;

    window.requestAnimationFrame(() => firstOptionRef.current?.focus());
  }, [open]);

  if (!open) return null;

  return (
    <section
      id="situations-panel"
      className="situations-panel"
      aria-labelledby="situations-panel-title"
      onKeyDown={(event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          onClose();
        }
      }}
    >
      <div className="situations-panel__header">
        <div>
          <span className="situations-panel__eyebrow">Mokomieji atvejai</span>
          <h2 id="situations-panel-title">Pasirinkite klinikinę situaciją</h2>
        </div>
        <button className="situations-panel__close" type="button" onClick={onClose}>
          Uždaryti
        </button>
      </div>

      <p className="situations-panel__safety">
        Tai mokomieji suaugusiųjų nuo 16 metų ūmios būklės atvejai. Pasirinkus situaciją,
        gyvybiniai rodikliai bus pateikti užduotyje, bet į skaičiuoklę automatiškai neįrašomi —
        juos įveskite patys. NEWS2 nepakeičia klinikinio vertinimo ir vietinių protokolų.
      </p>

      <ul className="situations-grid">
        {CLINICAL_SITUATIONS.map((situation, index) => (
          <li key={situation.id}>
            <button
              ref={index === 0 ? firstOptionRef : undefined}
              className="situation-option"
              type="button"
              aria-pressed={selectedId === situation.id}
              onClick={() => onSelect(situation.id)}
            >
              <span className="situation-option__title">{situation.title}</span>
              <span className="situation-option__summary">{situation.summary}</span>
              <span className="situation-option__action">
                {selectedId === situation.id ? 'Atidaryta' : 'Atidaryti atvejį'}
              </span>
            </button>
          </li>
        ))}
      </ul>

      <p className="situations-panel__source">
        NEWS2 skalė ir taikymo ribos pagal{' '}
        <a href="https://www.rcplondon.ac.uk/media/a4ibkkbf/news2-final-report_0_0.pdf" target="_blank" rel="noreferrer">
          Royal College of Physicians NEWS2 ataskaitą (2017)
        </a>
        .
      </p>
    </section>
  );
};

export default SituationsPanel;
